import { connect } from 'react-redux'
import { IStoreState } from '../../types'

import PromotionsSearch from '../../components/promotions/PromotionsSearch'
import { actionCreators } from '../../state/actions/organizations'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any): any {
  return {
    onInputChange: (title: string) => {
      dispatch(actionCreators.updatePromotionFilters({ search: title }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionsSearch)



// WEBPACK FOOTER //
// ./src/containers/promotions/PromotionsSearch.ts